<script setup lang="ts">
import type BankAccountsPicker from '@/components/user/account/BankAccounts/BankAccountsPicker.vue';

const bankAccountsRef = ref<InstanceType<typeof BankAccountsPicker> | null>(
  null,
);

const selectedBankAccountId = ref<number>();

const selectedKeyType = computed(() => {
  return bankAccountsRef.value?.pixKeysRef?.selectedKeyType ?? '';
});

const selectedKeyValue = computed(() => {
  return bankAccountsRef.value?.pixKeysRef?.selectedKeyValue ?? '';
});

const selectedPhoneNumber = computed(() => {
  return bankAccountsRef.value?.pixKeysRef?.selectedPhoneNumber ?? '';
});

const selectedPhoneDdi = computed(() => {
  return bankAccountsRef.value?.pixKeysRef?.selectedPhoneDdi ?? '';
});

const pixKeyError = computed(() => {
  return bankAccountsRef.value?.pixKeysRef?.pixKeyError ?? '';
});

const { pixKey, pixLoading } = storeToRefs(useUserDataStore());
const { getUserPixKey } = useUserDataStore();

const userPixKeyValue = computed(() => {
  return pixKey.value.value || '';
});

onBeforeMount(() => {
  if (!userPixKeyValue.value) {
    getUserPixKey();
  }
});

defineExpose({
  selectedKeyType,
  selectedKeyValue,
  selectedPhoneNumber,
  selectedPhoneDdi,
  selectedBankAccountId,
  pixKeyError,
});
</script>

<template>
  <div :class="$style.pixInfo">
    <BaseLoading
      class="!bg-bg-primary !absolute !rounded-none"
      :show="pixLoading"
    />

    <UserAccountBankAccountsPicker
      ref="bankAccountsRef"
      v-model="selectedBankAccountId"
    />
  </div>
</template>

<style module lang="scss">
.pixInfo {
  @apply relative px-0.5;
}
</style>
